import { useMutation } from "@apollo/client";
import { Button, Col, Input, Label, Row } from "reactstrap";
import deleteIcon from "../../../assets/images/delete-field.svg";
import { EMAIL_PATTERN } from "../../../utils/constant";
import { VERIFY_EMAIL } from "../gql";
import { Controller } from "react-hook-form";

const CandidateEmails = ({
  getValues,
  setValue,
  append,
  fields,
  register,
  errors,
  control,
  remove,
  setToggleEmailOrLinkdin,
  setVerifyEmailStatus,
}: any) => {
  const [verifyEmail] = useMutation(VERIFY_EMAIL);

  return (
    <div>
      <h5>Contact Emails</h5>

      <div>
        {fields?.map((item, index) => {
          return (
            <Row className="mb-3" key={index}>
              <Col xl="6" lg="6" md="12" xs="12" className="text-left">
                <input
                  type="hidden"
                  {...register(`emails.${index}.emailId`)}
                  defaultValue={item.emailId}
                />
                <Controller
                  name={`emails.${index}.email`}
                  control={control}
                  defaultValue={item?.email || ""}
                  rules={{
                    pattern: {
                      value: EMAIL_PATTERN,
                      message: "Email is not valid!",
                    },
                    validate: async (value) => {
                      if (value && value !== item?.email) {
                        setVerifyEmailStatus(true);

                        const { data } = await verifyEmail({
                          variables: { email: value },
                        });

                        setVerifyEmailStatus(false);

                        if (data?.verifyEmailExist?.exist) {
                          return "Email is already there.";
                        }

                        return true;
                      }
                      return true;
                    },
                  }}
                  render={({ field, fieldState }) => (
                    <>
                      <Input
                        {...field}
                        placeholder="Email"
                        value={field.value || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          field.onChange(value); // 🔥 RHF state update FIRST

                          // your custom logic
                          if (new RegExp(EMAIL_PATTERN).test(value)) {
                            setToggleEmailOrLinkdin(true);
                          } else {
                            setToggleEmailOrLinkdin(false);
                          }
                        }}
                        innerRef={field.ref}
                      />

                      {fieldState.error && (
                        <span className="text-danger">{fieldState.error.message}</span>
                      )}
                    </>
                  )}
                />
                <small className="text-danger">
                  {errors.emails && (errors?.emails as any)[index]?.email?.message}
                </small>
              </Col>

              <Col
                xl="6"
                lg="6"
                md="12"
                xs="12"
                className="d-flex align-items-end"
              >
                <div className="radio-delete m-0">
                  <Button
                    type="button"
                    disabled={fields.length === 1}
                    onClick={() => {
                      remove(index, item?.emailId);
                    }}
                    className="bg-transparent border-0"
                  >
                    <img
                      src={deleteIcon}
                      alt=""
                      width="20"
                      height="20"
                      className="m-0"
                    />
                  </Button>

                  <div>
                    <Label className="radio-container switchLabel m-0">
                      is Primary
                      <input
                        checked={item.isPrimary}
                        // disabled={fields.length === 1}
                        // defaultChecked={fields.length === 1}
                        {...register(`emails.${index}.isPrimary`, {
                          onChange: (e) => {
                            let val = [...getValues().emails];
                            if (val?.find((item) => item.isPrimary)) {
                              val = val?.map((item) => {
                                item.isPrimary = false;
                                return item;
                              });
                              val[index].isPrimary = e.target.checked;
                              setValue(`emails`, val);
                            }
                          }
                        })}
                        type="checkbox"
                      />
                      <span className="checkmark"></span>
                    </Label>
                  </div>
                </div>
              </Col>
            </Row>
          );
        })}
        <small className="text-danger">{errors?.emails?.message as any}</small>
        <div>
          <button
            type="button"
            onClick={() => {
              append({
                email: "",
                isPrimary: false,
                emailId: "",
              });
            }}
            className="buttonGenericStyle filledButton"
          >
            Add New Email
          </button>
        </div>
      </div>
    </div>
  );
};

export default CandidateEmails;
